import type { FormError } from '@rover/types/src/Form';

/**
 * Extracts a string error message from a FormError value.
 * FormError can be string | null | Array<Array<string | null>>, but
 * leaf-level validators always produce string | null at runtime.
 * This utility provides a runtime-safe narrowing instead of type assertions.
 */
export default function getStringError(error: FormError | undefined): string | null {
  if (error === undefined || error === null) return null;
  if (typeof error === 'string') return error;
  // Defensive: handle the array-of-arrays form if it ever appears
  if (Array.isArray(error)) {
    const flat = error.flat();
    return flat.find((e): e is string => typeof e === 'string') ?? null;
  }
  return null;
}
